import React, { Component } from 'react';

import TextSearch from 'app/components/common/TextSearch';

type propTypes = {
  onSubmit: (args: any) => void;
};
export default class GeneralTextSearch extends Component<propTypes> {
  state = {
    query: '',
  };

  render() {
    return (
      <form onSubmit={this.onSubmit}>
        <TextSearch
          focusOnMount={false}
          mode="header"
          onChange={this.onChange}
          // @ts-ignore
          value={this.state.query}
        />
      </form>
    );
  }

  onChange = (query: any) => {
    this.setState({ query });
  };

  onSubmit = (e: any) => {
    e.preventDefault();
    this.props.onSubmit({ query: this.state.query });
  };
}
